"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
const react_1 = __importDefault(require("react"));
exports.default = _ref => {
  let width = _ref.width,
    height = _ref.height;
  return react_1.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 44 34"
  }, react_1.default.createElement("defs", null, react_1.default.createElement("linearGradient", {
    id: "a",
    x1: "0%",
    y1: "49.994%",
    y2: "49.994%"
  }, react_1.default.createElement("stop", {
    offset: "0%",
    stopColor: "#FFF"
  }), react_1.default.createElement("stop", {
    offset: "29%",
    stopColor: "#FBFBFB"
  }), react_1.default.createElement("stop", {
    offset: "61%",
    stopColor: "#EEE"
  }), react_1.default.createElement("stop", {
    offset: "93%",
    stopColor: "#D8D8D8"
  }), react_1.default.createElement("stop", {
    offset: "100%",
    stopColor: "#D3D3D3"
  }))), react_1.default.createElement("g", {
    fill: "none",
    fillRule: "nonzero"
  }, react_1.default.createElement("path", {
    fill: "#F0EFEF",
    d: "M37.497 5.216c-.482-.254-.986-.489-1.5-.713L5.074 20.755c.44.272.88.536 1.358.79.477.254.988.487 1.5.713L38.86 6.004c-.44-.27-.88-.535-1.362-.788z"
  }), react_1.default.createElement("path", {
    fill: "#DBDADA",
    d: "M35.996 4.503V2.667L5.078 18.92v1.836z"
  }), react_1.default.createElement("path", {
    fill: "url(#a)",
    d: "M37.497 19.709c-8.098 4.266-20.933 4.486-29.564.713v1.836a19.706 19.706 0 0 1-2.858-1.503V18.93C1.698 16.787 0 14.168 0 11.545v10.691c0 2.955 2.145 5.91 6.433 8.164 8.58 4.508 22.486 4.508 31.064 0 4.29-2.252 6.433-5.21 6.433-8.164V11.545c0 2.954-2.143 5.91-6.433 8.164z"
  }), react_1.default.createElement("path", {
    fill: "#F5F6F6",
    d: "M35.999 2.667C27.366-1.11 14.529-.875 6.433 3.38 2.145 5.635 0 8.59 0 11.545c0 2.632 1.698 5.242 5.075 7.374L36 2.667zM38.859 4.168L7.933 20.422c8.629 3.773 21.466 3.553 29.564-.713 4.29-2.255 6.433-5.21 6.433-8.164 0-2.624-1.699-5.243-5.071-7.377z"
  })));
};